module.exports = __webpack_public_path__ + "static/media/exit.510853f7.jpg";